import {
    FortuneContents, FortuneResultDescSection,
    FortuneResultImg,
    FortuneResultImgSection,
    FortuneResultWrap
} from "src/styles/views/UserPage/Fortune"
import React, {useState} from "react"
import luck5Img from "src/assets/main/main7/main7luck_icon5.png"
import luck6Img from "src/assets/main/main7/main7luck_icon6.png"
import luck7Img from "src/assets/main/main7/main7luck_icon7.png"
import luck8Img from "src/assets/main/main7/main7luck_icon8.png"
import luck9Img from "src/assets/main/main7/main7luck_icon9.png"
import luck10Img from "src/assets/main/main7/main7luck_icon10.png"
import luck11Img from "src/assets/main/main7/main7luck_icon11.png"
import luck12Img from "src/assets/main/main7/main7luck_icon12.png"
import luck13Img from "src/assets/main/main7/main7luck_icon13.png"
import luck14Img from "src/assets/main/main7/main7luck_icon14.png"
import luck15Img from "src/assets/main/main7/main7luck_icon15.png"
import luck16Img from "src/assets/main/main7/main7luck_icon16.png"

import {useHoroScopeFortuneQueryData} from "src/hooks/reactquery";
import {TYPE_Horoscope_FORTUNE} from "src/service/constant/cmdtype";
import {useRecoilValue} from "recoil";
import {FortuneResultData} from "src/store/UserPage/fortune";
import useWindowDimensions from "src/hooks/useGetWindowSize";

const ResultImgList = [
    {text: "쥐띠", ImgSrc: luck5Img},
    {text: "소띠", ImgSrc: luck6Img},
    {text: "호랑이띠", ImgSrc: luck7Img},
    {text: "토끼띠", ImgSrc: luck8Img},
    {text: "용띠", ImgSrc: luck9Img},
    {text: "뱀띠", ImgSrc: luck10Img},
    {text: "말띠", ImgSrc: luck11Img},
    {text: "양띠", ImgSrc: luck12Img},
    {text: "원숭이띠", ImgSrc: luck13Img},
    {text: "닭띠", ImgSrc: luck14Img},
    {text: "개띠", ImgSrc: luck15Img},
    {text: "돼지띠", ImgSrc: luck16Img},

]

const HoroscopeFortune = () => {
    const UserFortuneData:any = useRecoilValue(FortuneResultData)
    const [Choice, seChoice] = useState(UserFortuneData?.YearsUnse?? "쥐띠")
    const {isSuccess, data: ScopeQueryData} = useHoroScopeFortuneQueryData(TYPE_Horoscope_FORTUNE)
    const {width} = useWindowDimensions()
    const ChoiceItems = isSuccess && ScopeQueryData?.Body?.YearsUnse?.find((element: { Title: string, CommonContents: string }) => element?.Title === Choice)
    return (
        <FortuneContents paddingBottom={'63px'}>
            <h3>오늘의 띠별운세</h3>
            <FortuneResultWrap>
                <FortuneResultImgSection className={'horoscope'}>
                    {ResultImgList.map((element: { text: string, ImgSrc: string }) => (
                        <section key={element.text}>
                            <FortuneResultImg
                                active={Choice === element.text}
                                onClick={() => seChoice(element.text)}
                                size={width > 1200 ? '82px' : '72px'}
                            >
                                <img className="horoscope" src={element.ImgSrc} alt=""/>
                            </FortuneResultImg>
                            <p>{element.text}</p>
                        </section>
                    ))}
                </FortuneResultImgSection>
                <FortuneResultDescSection>
                    <pre>{ChoiceItems?.CommonContents}</pre>
                    {ChoiceItems?.YearsUnseInfo?.map((element:{Year:string, Contents:string})=>(
                        <section key={element.Year}>
                            <p>{element.Year}</p>
                            <span>{element.Contents}</span>
                        </section>
                    ))}
                </FortuneResultDescSection>
            </FortuneResultWrap>
        </FortuneContents>
    )
}
export default HoroscopeFortune